export const mapThreatsTypesConst = {
  'FAKE_NEWS': 'Fake news',
  'DATA_LEAK': 'Data leak',
  'COORDINATED_ATTACK': 'Coordinated online attack',
  'COORDINATED_ACTIVITY': 'Coordinated offline activity',
  'HOSTILE_NARRATIVE': 'Malign narrative',
  'DEBUNK': 'Debunk',
  'POSITIVE_NARRATIVE': 'Positive narrative',
  'GOVERNMENT_COMMUNICATION': 'Government communication',

  'FAKE_DISINFORMATION': 'Fake/Disinformation',
  'MANIPULATION_MISINFORMATION': 'Manipulation/Misinformation',
  'DISPROOF_DEBUNK': 'Disproof/Debunk',
  'STRATEGIC_NARRATIVE_MESSAGE': 'Strategic narrative/message (reporting)',
  'UNCLASSIFIED_THREAT': 'Unclassified threat',
  'OTHER': 'Other_',

  'CONSUMER_BACKLASH': 'Consumer backlash',
  'NEGATIVE_MEDIA_COVERAGE': 'Negative media coverage',
  'INSIDER_LEAK': 'Insider leak',
  'NATURAL_DISASTER': 'Natural disaster',
  'POLITICAL_CIVIL_UNREST': 'Political/Civil unrest',
  'CRIMINAL_ACTIVITY': 'Criminal activity',
  'LEGAL_REGULATORY': 'Legal/Regulatory',
  'PRODUCT_MALFUNCTION': 'Product malfunction',
  'CYBER_ATTACK': 'Cyber attack',
  'GEOPOLITICAL_ESCALATION': 'Geopolitical escalation',
  'LARGE_SCALE_ECOLOGICAL_INDUSTRIAL_DISASTER': 'Large-scale ecological/industrial disaster',
  'DETERIORATION_OF_INTERNATIONAL_RELATIONS': 'Deterioration of international relations',
  'GLOBAL_MALFUNCTION': 'Global malfunction',
  'DISINFORMATION_CAMPAIGN': 'Disinformation campaign',
  'FACILITATE_STATE_PROPAGANDA': 'Facilitate State Propaganda',
  'LEVERAGE_EXISTING_NARRATIVES': 'Leverage Existing Narratives',
  'USE_EXISTING_HASHTAG': 'Use Existing Hashtag',
  'CREATE_CLICKBAIT': 'Create Clickbait',
  'CONDUCT_CROWDFUNDING_CAMPAIGNS': 'Conduct Crowdfunding Campaigns',
  'AMPLIFY_EXISTING_CONSPIRACY_THEORY_NARRATIVES': 'Amplify Existing Conspiracy Theory Narratives',
  'DEVELOP_ORIGINAL_CONSPIRACY_THEORY_NARRATIVES': 'Develop Original Conspiracy Theory Narratives',
  'ONLINE_POLLS': 'Online Polls',
  'DEMAND_INSURMOUNTABLE_PROOF': 'Demand Insurmountable Proof',
  'BOYCOTT_CANCEL_OPPONENTS': 'Boycott/"Cancel" Opponents',
  'HARASS_PEOPLE_BASED_ON_IDENTITIES': 'Harass People Based on Identities',
  'THREATEN_TO_DOX': 'Threaten to Dox',
  'DOX': 'Dox',
  'CONDUCT_SWARMING': 'Conduct Swarming',
  'PAY_FOR_PHYSICAL_ACTION': 'Pay for Physical Action',
  'CONDUCT_SYMBOLIC_ACTION': 'Conduct Symbolic Action',
  'CONTINUE_TO_AMPLIFY': 'Continue to Amplify',
  'SELL_MERCHANDISE': 'Sell Merchandise',
  'DEGRADE_ADVERSARY': 'Degrade Adversary',
  'RESPOND_TO_BREAKING_NEWS_EVENT_OR_ACTIVE_CRISIS': 'Respond to Breaking News Event or Active Crisis',
  'DISCREDIT_CREDIBLE_SOURCES': 'Discredit Credible Sources',
  'DISTORT': 'Distort',
  'DISTRACT': 'Distract',
  'DISMAY': 'Dismay',
  'DIVIDE': 'Divide',
  'DEVELOP_NEW_NARRATIVES': 'Develop New Narratives',
  'INTEGRATE_TARGET_AUDIENCE_VULNERABILITIES_INTO_NARRATIVE': 'Integrate Target Audience Vulnerabilities into Narrative',
  'APPROPRIATE_CONTENT': 'Appropriate Content',
  'DEVELOP_AI_GENERATED_TEXT': 'Develop AI-Generated Text',
  'DEVELOP_INAUTHENTIC_NEWS_ARTICLES': 'Develop Inauthentic News Articles',
  'DEVELOP_OPINION_ARTICLE': 'Develop Opinion Article',
  'MACHINE_TRANSLATED_TEXT': 'Machine Translated Text',
  'DEVELOP_OWNED_MEDIA_ASSETS': 'Develop Owned Media Assets',
  'JOURNALIST_PERSONA': 'Journalist Persona',
  'ACTIVIST_PERSONA': 'Activist Persona',
  'HACKTIVIST_PERSONA': 'Hacktivist Persona',
  'MILITARY_PERSONNEL_PERSONA': 'Military Personnel Persona',
  'RESEARCHER_PERSONA': 'Researcher Persona',
  'EXPERT_PERSONA': 'Expert Persona',
  'PARTY_OFFICIAL_PERSONA': 'Party Official Persona',
  'GOVERNMENT_OFFICIAL_PERSONA': 'Government Official Persona',
  'INSTITUTIONAL_PERSONA': 'Institutional Persona',
  'FACT_CHECKING_ORGANISATION_PERSONA': 'Fact Checking Organisation Persona',
  'THINK_TANK_PERSONA': 'Think Tank Persona',
  'BUSINESS_PERSONA': 'Business Persona',
  'GOVERNMENT_INSTITUTION_PERSONA': 'Government Institution Persona',
  'NGO_PERSONA': 'NGO Persona',
  'CREATE_INAUTHENTIC_NEWS_SITES': 'Create Inauthentic News Sites',
  'LEVERAGE_EXISTING_INAUTHENTIC_NEWS_SITES': 'Leverage Existing Inauthentic News Sites',
  'CREATE_LOCALISED_CONTENT': 'Create Localised Content',
  'FORMAL_DIPLOMATIC_CHANNELS': 'Formal Diplomatic Channels',
  'TV': 'TV',
  'POST_ACROSS_GROUPS': 'Post across Groups',
  'POST_ACROSS_PLATFORM': 'Post across Platform',
  'USE_CONTESTS_AND_PRIZES': 'Use Contests and Prizes',
  'BYPASS_CONTENT_BLOCKING': 'Bypass Content Blocking',
  'DIRECT_USERS_TO_ALTERNATIVE_PLATFORMS': 'Direct Users to Alternative Platforms',
  'CALL_TO_ACTION_TO_ATTEND': 'Call to Action to Attend',
  'ENCOURAGE_PHYSICAL_VIOLENCE': 'Encourage Physical Violence',
  'DENY_INVOLVEMENT': 'Deny Involvement',
  'SMEAR': 'Smear',
  'THWART': 'Thwart',
  'POLARISE': 'Polarise',
  'DEFEND_REPUTATION': 'Defend Reputation',
  'JUSTIFY_ACTION': 'Justify Action',
  'ENERGISE_SUPPORTERS': 'Energise Supporters',
  'BOOST_REPUTATION': 'Boost Reputation',
  'CULTIVATE_SUPPORT_FOR_INITIATIVE': 'Cultivate Support for Initiative',
  'CULTIVATE_SUPPORT_FOR_ALLY': 'Cultivate Support for Ally',
  'RECRUIT_MEMBERS': 'Recruit Members',
  'RAISE_FUNDS': 'Raise Funds',
  'ENCOURAGE': 'Encourage',
  'PROVOKE': 'Provoke',
  'COMPEL': 'Compel',
  'DISCOURAGE': 'Discourage',
  'SILENCE': 'Silence',
  'DETER': 'Deter',
  'DEFAME': 'Defame',
  'INTIMIDATE': 'Intimidate',
  'SPREAD_HATE': 'Spread Hate',
  'VERIFIED_ACCOUNT_ASSET': 'Verified Account Asset',
  'AUTOMATED_ACCOUNT_ASSET': 'Automated Account Asset',
  'CROWDFUNDING_PLATFORM': 'Crowdfunding Platform',
  'ECOMMERCE_PLATFORM': 'eCommerce Platform',
  'CRYPTOCURRENCY_EXCHANGE_PLATFORM': 'Cryptocurrency Exchange Platform',
  'CRYPTOCURRENCY_WALLET': 'Cryptocurrency Wallet',
  'LOOKALIKE_DOMAIN': 'Lookalike Domain',
  'ONLINE_COMMUNITY_GROUP': 'Online Community Group',
  'CHAT_COMMUNITY_SERVER': 'Chat Community Server',
  'DATING_PLATFORM': 'Dating Platform',
  'SHORTENED_LINK_ASSET': 'Shortened Link Asset',
  'GEOBLOCKED_ASSET': 'Geoblocked Asset',
}

export const mapThreatsStatus = {
  'PENDING': 'Pending',
  'ACCEPTED': 'Accepted',
  'DECLINED': 'Declined'
}

export const mapThreatsSubjects = {
  'POLITICS': 'Politics',
  'FINANCE': 'Economy and finance',
  'PUBLIC_COMPANIES': 'Public companies',
  'ELECTIONS': 'Elections',
  'DEFENSE': 'Defence',
  'THREAT': 'Threat',
  'CYBER': 'Cyber',
  'EUROPEAN_INTEGRATION': "European Integration",
  'UKRAINE__NATO': "Ukraine <> NATO",
  'HEALTHCARE': "Healthcare",
  'SOCIAL_CULTURAL': "Social/cultural",
  'DECOLONIZATION': "Decolonization",
  'ENERGY_INDEPENDENCE': "Energy Independence",
  'ANTI_CORRUPTION': "Anti-corruption",
  'ECOLOGY': "Ecology",
  'POST_WAR_RECOVERY': "Reconsruction of Ukraine",
  'BUSINESS_AND_INVESTMENTS': "Business & investments",
  'PUBLIC_SERVICES': "Public services",
  'VOLUNTEERS': "Volunteers",
  'NATIONAL_MINORITIES': "National minorities",
  'COLLABORANTS': "Collaborants",
  'LOCAL_GOVERNMENT': "Local Governance",
  'WEAPON_SUPPLY': "Weapon supply",
  'UKRAINE__PARTNERS': "Ukraine <> Partners",
  'REFORMS': "Reforms",
  'REGION_SPECIFIC': "Region-specific",
  'RUSSIAN_NARRATIVES': "Russian narratives",
  'MOBILIZATION': "Mobilization",
  'CONSTITUTIONAL_STATE': 'Constitutional State',
  'DEFENSE_AND_SECURITY': 'Defense and Security',
  'ARMED_FORCES_REFORM': 'Reform of the Armed Forces',
  'ARMED_FORCES_CORRUPTION': 'Corruption in the Armed Forces',
  'FRONTLINE_REPORT': 'Frontline report',
  'PEACE_TALKS': 'Peace talks',

  'TECH': 'Tech',
  'SPORT': 'Sport',
  'AUTOMOTIVE': 'Automotive',
  'AEROSPACE': 'Aerospace',
  'ENTERTAINMENT': 'Entertainment',
  'PHARMACEUTICS': 'Pharmaceutics',
  'MEDIA': 'Media',
  'RETAIL': 'Retail',
  'FOOD': 'Food',
  'ECOMMERCE': 'E-commerce',

  'PRESS_FREEDOM': 'Freedom of press and speech',
  'LGBT': 'LGBT+',
  'CORRUPTION': 'Corruption',
  'RELIGIOUS_AFFAIRS': 'Religious Affairs',
  'HUMAN_RIGHTS': 'Human Rights',
  'CHINA': 'China',
  'USA': 'United States',
  'Israel_Palestina': 'Israel - Palestina',
  'WAR_IN_UKRAINE': 'War in Ukraine',
  'KAZAKH_IDENTITY': 'Kazakh identity and sovereignty',
  'IRAN': 'Iran',
  'PA_HEALTH_FOOD_SAFETY': 'PA-Health & PA-Food Safety',
  'PA_AGRICULTURE': 'PA-Agriculture',
  'PA_BUDGET_ECONOMIC_AFFAIRS': 'PA-Budget, Economic Affairs, Internal Market, Industry, Entrepreneurship, Financial Services, Taxation',
  'PA_ENVIRONMENT': 'PA-Environment',
  'MERCOSUR': 'Mercosur',
  'PA_ENERGY_HOUSING': 'PA-Energy & Housing',
  'PA_COMPETITION': 'PA-Competition',
  'PA_TRANSPORT': 'PA-Transport',
  'PA_ADMINISTRATION_INSTITUTIONAL_AFFAIRS': 'PA-Administration, Anti-Fraud, Communication, Institutional Affairs',
  'PA_DEFENCE': 'PA-Defence',
  'PA_RESEARCH_SCIENCE_INNOVATION': 'PA-Research, Science and Innovation',
  'PA_TRADE': 'PA-Trade',
  'PA_MARITIME_AFFAIRS': 'PA-Maritime Affairs',
  'PA_REGIO': 'PA-Regio',
  'PA_EMPLOYMENT_SOCIAL_AFFAIRS': 'PA-Employment, Social Affairs, Education, Culture, Demography',
  'PA_ENLARGEMENT_FOREIGN_AFFAIRS': 'PA-Enlargement, European Neighbourhood, International Cooperation, EU Foreign Affairs',
  'PA_HUMANITARIAN_AID': 'PA-Humanitarian Aid',
  'PA_RULE_OF_LAW_JUSTICE': 'PA-Rule of Law, Democracy, Consumer Policy, Justice',
  'PA_DIGITAL_ECONOMY': 'PA-Digital Economy',
  'THE_EU': 'The EU',
  'PA_MIGRATION_HOME_AFFAIRS': 'PA-Migration, PA-Home Affairs',
  'PA_ANTI_FRAUD': 'PA-Anti-Fraud',
  'PA_BUDGET': 'PA-Budget',
  'PA_CLIMATE_ACTION': 'PA-Climate Action',
  'PA_CONSUMER_POLICY': 'PA-Consumer Policy',
  'PA_CRISIS_PREPAREDNESS': 'PA-Crisis Preparedness',
  'PA_CULTURE': 'PA-Culture',
  'PA_DEMOCRACY': 'PA-Democracy',
  'PA_DEMOGRAPHY': 'PA-Demography',
  'PA_ECONOMIC_AFFAIRS': 'PA-Economic Affairs',
  'PA_EDUCATION': 'PA-Education',
  'PA_EMPLOYMENT': 'PA-Employment',
  'PA_ENERGY': 'PA-Energy',
  'PA_ENLARGEMENT': 'PA-Enlargement',
  'PA_ENTREPRENEURSHIP': 'PA-Entrepreneurship',
  'PA_EU_FOREIGN_AFFAIRS': 'PA-EU Foreign Affairs',
  'PA_EUROPEAN_NEIGHBOURHOOD': 'PA-European Neighbourhood',
  'PA_FINANCIAL_SERVICES': 'PA-Financial Services',
  'PA_FOOD_SAFETY': 'PA-Food Safety',
  'PA_GENDER_EQUALITY': 'PA-Gender Equality',
  'PA_HEALTH': 'PA-Health',
  'PA_HOME_AFFAIRS': 'PA-Home Affairs',
  'PA_HOUSING': 'PA-Housing',
  'PA_INDUSTRY': 'PA-Industry',
  'PA_INSTITUTIONAL_AFFAIRS': 'PA-Institutional Affairs',
  'PA_INTERNAL_MARKET': 'PA-Internal Market',
  'PA_INTERNATIONAL_COOPERATION': 'PA-International Cooperation',
  'PA_JUSTICE': 'PA-Justice',
  'PA_MIGRATION': 'PA-Migration',
  'PA_RULE_OF_LAW': 'PA-Rule of Law',
  'PA_SOCIAL_AFFAIRS': 'PA-Social Affairs',
  'PA_TAXATION': 'PA-Taxation',
}

export const GEO_SCOPE_OPTIONS = [
  { value: 'Afghanistan', label: 'Afghanistan' },
  { value: 'Albania', label: 'Albania' },
  { value: 'Algeria', label: 'Algeria' },
  { value: 'Andorra', label: 'Andorra' },
  { value: 'Angola', label: 'Angola' },
  { value: 'Antigua and Barbuda', label: 'Antigua and Barbuda' },
  { value: 'Arab World', label: 'Arab World' },
  { value: 'Argentina', label: 'Argentina' },
  { value: 'Armenia', label: 'Armenia' },
  { value: 'Australia', label: 'Australia' },
  { value: 'Austria', label: 'Austria' },
  { value: 'Azerbaijan', label: 'Azerbaijan' },
  { value: 'Bahamas', label: 'Bahamas' },
  { value: 'Bahrain', label: 'Bahrain' },
  { value: 'Bangladesh', label: 'Bangladesh' },
  { value: 'Barbados', label: 'Barbados' },
  { value: 'Belarus', label: 'Belarus' },
  { value: 'Belgium', label: 'Belgium' },
  { value: 'Belize', label: 'Belize' },
  { value: 'Benin', label: 'Benin' },
  { value: 'Bhutan', label: 'Bhutan' },
  { value: 'Bolivia', label: 'Bolivia' },
  { value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina' },
  { value: 'Botswana', label: 'Botswana' },
  { value: 'Brazil', label: 'Brazil' },
  { value: 'Brunei', label: 'Brunei' },
  { value: 'Bulgaria', label: 'Bulgaria' },
  { value: 'Burkina Faso', label: 'Burkina Faso' },
  { value: 'Burundi', label: 'Burundi' },
  { value: 'Cabo Verde', label: 'Cabo Verde' },
  { value: 'Cambodia', label: 'Cambodia' },
  { value: 'Cameroon', label: 'Cameroon' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Cayman Islands', label: 'Cayman Islands' },
  { value: 'Central African Republic', label: 'Central African Republic' },
  { value: 'Chad', label: 'Chad' },
  { value: 'Chile', label: 'Chile' },
  { value: 'China', label: 'China' },
  { value: 'Colombia', label: 'Colombia' },
  { value: 'Comoros', label: 'Comoros' },
  { value: 'Costa Rica', label: 'Costa Rica' },
  { value: 'Croatia', label: 'Croatia' },
  { value: 'Cuba', label: 'Cuba' },
  { value: 'Cyprus', label: 'Cyprus' },
  { value: 'Czechia', label: 'Czechia' },
  { value: 'Democratic Republic of the Congo', label: 'Democratic Republic of the Congo' },
  { value: 'Denmark', label: 'Denmark' },
  { value: 'Djibouti', label: 'Djibouti' },
  { value: 'Dominica', label: 'Dominica' },
  { value: 'Dominican Republic', label: 'Dominican Republic' },
  { value: 'Ecuador', label: 'Ecuador' },
  { value: 'Egypt', label: 'Egypt' },
  { value: 'El Salvador', label: 'El Salvador' },
  { value: 'Equatorial Guinea', label: 'Equatorial Guinea' },
  { value: 'Eritrea', label: 'Eritrea' },
  { value: 'Estonia', label: 'Estonia' },
  { value: 'Eswatini', label: 'Eswatini' },
  { value: 'Ethiopia', label: 'Ethiopia' },
  { value: 'European Union', label: 'European Union' },
  { value: 'Fiji', label: 'Fiji' },
  { value: 'Finland', label: 'Finland' },
  { value: 'France', label: 'France' },
  { value: 'Gabon', label: 'Gabon' },
  { value: 'Gambia', label: 'Gambia' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Georgia TOT', label: 'Georgia TOT' },
  { value: 'Germany', label: 'Germany' },
  { value: 'Ghana', label: 'Ghana' },
  { value: 'Greece', label: 'Greece' },
  { value: 'Grenada', label: 'Grenada' },
  { value: 'Guatemala', label: 'Guatemala' },
  { value: 'Guinea', label: 'Guinea' },
  { value: 'Guinea-Bissau', label: 'Guinea-Bissau' },
  { value: 'Guyana', label: 'Guyana' },
  { value: 'Haiti', label: 'Haiti' },
  { value: 'Honduras', label: 'Honduras' },
  { value: 'Hong Kong', label: 'Hong Kong' },
  { value: 'Hungary', label: 'Hungary' },
  { value: 'Iceland', label: 'Iceland' },
  { value: 'India', label: 'India' },
  { value: 'Indonesia', label: 'Indonesia' },
  { value: 'Iran', label: 'Iran' },
  { value: 'Iraq', label: 'Iraq' },
  { value: 'Ireland', label: 'Ireland' },
  { value: 'Israel', label: 'Israel' },
  { value: 'Italy', label: 'Italy' },
  { value: 'Ivory Coast', label: 'Ivory Coast' },
  { value: 'Jamaica', label: 'Jamaica' },
  { value: 'Japan', label: 'Japan' },
  { value: 'Jordan', label: 'Jordan' },
  { value: 'Kazakhstan', label: 'Kazakhstan' },
  { value: 'Kenya', label: 'Kenya' },
  { value: 'Kiribati', label: 'Kiribati' },
  { value: 'Kosovo', label: 'Kosovo' },
  { value: 'Kuwait', label: 'Kuwait' },
  { value: 'Kyrgyzstan', label: 'Kyrgyzstan' },
  { value: 'Laos', label: 'Laos' },
  { value: 'Latvia', label: 'Latvia' },
  { value: 'Lebanon', label: 'Lebanon' },
  { value: 'Lesotho', label: 'Lesotho' },
  { value: 'Liberia', label: 'Liberia' },
  { value: 'Libya', label: 'Libya' },
  { value: 'Liechtenstein', label: 'Liechtenstein' },
  { value: 'Lithuania', label: 'Lithuania' },
  { value: 'Luxembourg', label: 'Luxembourg' },
  { value: 'Madagascar', label: 'Madagascar' },
  { value: 'Malawi', label: 'Malawi' },
  { value: 'Malaysia', label: 'Malaysia' },
  { value: 'Maldives', label: 'Maldives' },
  { value: 'Mali', label: 'Mali' },
  { value: 'Malta', label: 'Malta' },
  { value: 'Marshall Islands', label: 'Marshall Islands' },
  { value: 'Mauritania', label: 'Mauritania' },
  { value: 'Mauritius', label: 'Mauritius' },
  { value: 'Mexico', label: 'Mexico' },
  { value: 'Micronesia', label: 'Micronesia' },
  { value: 'Moldova', label: 'Moldova' },
  { value: 'Monaco', label: 'Monaco' },
  { value: 'Mongolia', label: 'Mongolia' },
  { value: 'Montenegro', label: 'Montenegro' },
  { value: 'Morocco', label: 'Morocco' },
  { value: 'Mozambique', label: 'Mozambique' },
  { value: 'Myanmar', label: 'Myanmar' },
  { value: 'Namibia', label: 'Namibia' },
  { value: 'Nauru', label: 'Nauru' },
  { value: 'Nepal', label: 'Nepal' },
  { value: 'Netherlands', label: 'Netherlands' },
  { value: 'New Zealand', label: 'New Zealand' },
  { value: 'Nicaragua', label: 'Nicaragua' },
  { value: 'Niger', label: 'Niger' },
  { value: 'Nigeria', label: 'Nigeria' },
  { value: 'North Korea', label: 'North Korea' },
  { value: 'North Macedonia', label: 'North Macedonia' },
  { value: 'Norway', label: 'Norway' },
  { value: 'Oman', label: 'Oman' },
  { value: 'Pakistan', label: 'Pakistan' },
  { value: 'Palau', label: 'Palau' },
  { value: 'Palestine', label: 'Palestine' },
  { value: 'Panama', label: 'Panama' },
  { value: 'Papua New Guinea', label: 'Papua New Guinea' },
  { value: 'Paraguay', label: 'Paraguay' },
  { value: 'Peru', label: 'Peru' },
  { value: 'Philippines', label: 'Philippines' },
  { value: 'Poland', label: 'Poland' },
  { value: 'Portugal', label: 'Portugal' },
  { value: 'Qatar', label: 'Qatar' },
  { value: 'Republic of the Congo', label: 'Republic of the Congo' },
  { value: 'Romania', label: 'Romania' },
  { value: 'Russia', label: 'Russia' },
  { value: 'Rwanda', label: 'Rwanda' },
  { value: 'Saint Kitts and Nevis', label: 'Saint Kitts and Nevis' },
  { value: 'Saint Lucia', label: 'Saint Lucia' },
  { value: 'Saint Vincent and the Grenadines', label: 'Saint Vincent and the Grenadines' },
  { value: 'Samoa', label: 'Samoa' },
  { value: 'San Marino', label: 'San Marino' },
  { value: 'Sao Tome and Principe', label: 'Sao Tome and Principe' },
  { value: 'Saudi Arabia', label: 'Saudi Arabia' },
  { value: 'Scotland', label: 'Scotland' },
  { value: 'Senegal', label: 'Senegal' },
  { value: 'Serbia', label: 'Serbia' },
  { value: 'Seychelles', label: 'Seychelles' },
  { value: 'Sierra Leone', label: 'Sierra Leone' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'Slovakia', label: 'Slovakia' },
  { value: 'Slovenia', label: 'Slovenia' },
  { value: 'Solomon Islands', label: 'Solomon Islands' },
  { value: 'Somalia', label: 'Somalia' },
  { value: 'South Africa', label: 'South Africa' },
  { value: 'South Korea', label: 'South Korea' },
  { value: 'South Sudan', label: 'South Sudan' },
  { value: 'Spain', label: 'Spain' },
  { value: 'Sri Lanka', label: 'Sri Lanka' },
  { value: 'Sudan', label: 'Sudan' },
  { value: 'Suriname', label: 'Suriname' },
  { value: 'Sweden', label: 'Sweden' },
  { value: 'Switzerland', label: 'Switzerland' },
  { value: 'Syria', label: 'Syria' },
  { value: 'Taiwan', label: 'Taiwan' },
  { value: 'Tajikistan', label: 'Tajikistan' },
  { value: 'Tanzania', label: 'Tanzania' },
  { value: 'Thailand', label: 'Thailand' },
  { value: 'Timor', label: 'Timor' },
  { value: 'Timor-Leste', label: 'Timor-Leste' },
  { value: 'Togo', label: 'Togo' },
  { value: 'Tonga', label: 'Tonga' },
  { value: 'Trinidad and Tobago', label: 'Trinidad and Tobago' },
  { value: 'Tunisia', label: 'Tunisia' },
  { value: 'Turkey', label: 'Turkey' },
  { value: 'Turkmenistan', label: 'Turkmenistan' },
  { value: 'Tuvalu', label: 'Tuvalu' },
  { value: 'Uganda', label: 'Uganda' },
  { value: 'Ukraine', label: 'Ukraine' },
  { value: 'Ukraine TOT', label: 'Ukraine TOT' },
  { value: 'United Arab Emirates', label: 'United Arab Emirates' },
  { value: 'United Kingdom', label: 'United Kingdom' },
  { value: 'United States of America', label: 'United States of America' },
  { value: 'Uruguay', label: 'Uruguay' },
  { value: 'Uzbekistan', label: 'Uzbekistan' },
  { value: 'Vanuatu', label: 'Vanuatu' },
  { value: 'Vatican', label: 'Vatican' },
  { value: 'Venezuela', label: 'Venezuela' },
  { value: 'Vietnam', label: 'Vietnam' },
  { value: 'Wales', label: 'Wales' },
  { value: 'Yemen', label: 'Yemen' },
  { value: 'Zambia', label: 'Zambia' },
  { value: 'Zimbabwe', label: 'Zimbabwe' },
];


export const INCIDENT_TYPE_OPTIONS = [
  {
    value: 'FAKE_NEWS',
    label: 'Fake news',
  },
  {
    value: 'DATA_LEAK',
    label: 'Data leak',
  },
  {
    value: 'HOSTILE_NARRATIVE',
    label: 'Malign narrative',
  },
  {
    value: 'COORDINATED_ATTACK',
    label: 'Coordinated online attack',
  },
  {
    value: 'COORDINATED_ACTIVITY',
    label: 'Coordinated offline activity',
  },
  {
    value: 'DEBUNK',
    label: 'Debunk',
  },
  {
    value: 'POSITIVE_NARRATIVE',
    label: 'Positive narrative',
  },
  {
    value: 'GOVERNMENT_COMMUNICATION',
    label: 'Government communication',
  },
  {
    value: 'FAKE_DISINFORMATION',
    label: 'Fake/Disinformation',
    is_ucbi: true,
  },
  {
    value: 'MANIPULATION_MISINFORMATION',
    label: 'Manipulation/Misinformation',
    is_ucbi: true,
  },
  {
    value: 'DISPROOF_DEBUNK',
    label: 'Disproof/Debunk',
    is_ucbi: true,
  },
  {
    value: 'STRATEGIC_NARRATIVE_MESSAGE',
    label: 'Strategic narrative/message (reporting)',
    is_ucbi: true,
  },
  {
    value: 'UNCLASSIFIED_THREAT',
    label: 'Unclassified threat',
    is_ucbi: true,
  },
  {
    value: 'OTHER',
    label: 'Other_',
    is_ucbi: true,
  },
  {
    value: 'CONSUMER_BACKLASH',
    label: 'Consumer backlash',
  },
  {
    value: 'NEGATIVE_MEDIA_COVERAGE',
    label: 'Negative media coverage',
  },
  {
    value: 'INSIDER_LEAK',
    label: 'Insider leak',
  },
  {
    value: 'NATURAL_DISASTER',
    label: 'Natural disaster',
  },
  {
    value: 'POLITICAL_CIVIL_UNREST',
    label: 'Political/Civil unrest',
  },
  {
    value: 'CRIMINAL_ACTIVITY',
    label: 'Criminal activity',
  },
  {
    value: 'LEGAL_REGULATORY',
    label: 'Legal/Regulatory',
  },
  {
    value: 'PRODUCT_MALFUNCTION',
    label: 'Product malfunction',
  },
  {
    value: 'CYBER_ATTACK',
    label: 'Cyber attack',
  },
  {
    value: 'GEOPOLITICAL_ESCALATION',
    label: 'Geopolitical escalation',
  },
  {
    value: 'LARGE_SCALE_ECOLOGICAL_INDUSTRIAL_DISASTER',
    label: 'Large-scale ecological/industrial disaster',
  },
  {
    value: 'DETERIORATION_OF_INTERNATIONAL_RELATIONS',
    label: 'Deterioration of international relations',
  },
  {
    value: 'GLOBAL_MALFUNCTION',
    label: 'Global malfunction',
  },
  {
    value: 'DISINFORMATION_CAMPAIGN',
    label: 'Disinformation campaign',
  },
]

export const INCIDENT_TYPE_OPTIONS_UCBI = [
  {
    value: 'FAKE_DISINFORMATION',
    label: 'Fake/Disinformation1',
    is_ucbi: true,
  },
  {
    value: 'MANIPULATION_MISINFORMATION',
    label: 'Manipulation/Misinformation1',
    is_ucbi: true,
  },
  {
    value: 'DISPROOF_DEBUNK',
    label: 'Disproof/Debunk1',
    is_ucbi: true,
  },
  {
    value: 'STRATEGIC_NARRATIVE_MESSAGE',
    label: 'Strategic narrative/message (reporting)1',
    is_ucbi: true,
  },
  {
    value: 'UNCLASSIFIED_THREAT',
    label: 'Unclassified threat1',
    is_ucbi: true,
  },
  {
    value: 'OTHER',
    label: 'Other_1',
    is_ucbi: true,
  },
]

export const TOPICS_OPTIONS = [
  {
    value: 'POLITICS',
    label: 'Politics',
  },
  {
    value: 'FINANCE',
    label: 'Economy and finance',
  },
  {
    value: 'PUBLIC_COMPANIES',
    label: 'Public companies',
  },
  {
    value: 'ELECTIONS',
    label: 'Elections',
  },
  {
    value: 'THREAT',
    label: 'Threat',
  },
  {
    value: 'DEFENSE',
    label: 'Defence',
  },
  {
    value: 'CYBER',
    label: 'Cyber',
  },
  {
    value: 'EUROPEAN_INTEGRATION',
    label: 'European Integration',
  },
  {
    value: 'UKRAINE__NATO',
    label: 'Ukraine <> NATO',
  },
  {
    value: 'HEALTHCARE',
    label: 'Healthcare',
  },
  {
    value: 'SOCIAL_CULTURAL',
    label: 'Social/cultural',
  },
  {
    value: 'DECOLONIZATION',
    label: 'Decolonization',
  },
  {
    value: 'ENERGY_INDEPENDENCE',
    label: 'Energy Independence',
  },
  {
    value: 'ANTI_CORRUPTION',
    label: 'Anti-corruption',
  },
  {
    value: 'ECOLOGY',
    label: 'Ecology',
  },
  {
    value: 'POST_WAR_RECOVERY',
    label: 'Reconsruction of Ukraine',
  },
  {
    value: 'BUSINESS_AND_INVESTMENTS',
    label: 'Business & investments',
  },
  {
    value: 'PUBLIC_SERVICES',
    label: 'Public services',
  },
  {
    value: 'VOLUNTEERS',
    label: 'Volunteers',
  },
  {
    value: 'NATIONAL_MINORITIES',
    label: 'National minorities',
  },
  {
    value: 'COLLABORANTS',
    label: 'Collaborants',
  },
  {
    value: 'LOCAL_GOVERNMENT',
    label: 'Local Governance',
  },
  {
    value: 'WEAPON_SUPPLY',
    label: 'Weapon supply',
  },
  {
    value: 'UKRAINE__PARTNERS',
    label: 'Ukraine <> Partners',
  },
  {
    value: 'REFORMS',
    label: 'Reforms',
  },
  {
    value: 'REGION_SPECIFIC',
    label: 'Region-specific',
  },
  {
    value: 'RUSSIAN_NARRATIVES',
    label: 'Russian narratives',
  },
  {
    value: 'MOBILIZATION',
    label: 'Mobilization',
  },
  {
    value: 'CONSTITUTIONAL_STATE',
    label: 'Constitutional State',
  },
  {
    value: 'DEFENSE_AND_SECURITY',
    label: 'Defense and Security',
  },
  {
    value: 'TECH',
    label: 'Tech'
  },
  {
    value: 'SPORT',
    label: 'Sport'
  },
  {
    value: 'AUTOMOTIVE',
    label: 'Automotive'
  },
  {
    value: 'AEROSPACE',
    label: 'Aerospace'
  },
  {
    value: 'ENTERTAINMENT',
    label: 'Entertainment'
  },
  {
    value: 'PHARMACEUTICS',
    label: 'Pharmaceutics'
  },
  {
    value: 'MEDIA',
    label: 'Media'
  },
  {
    value: 'RETAIL',
    label: 'Retail'
  },
  {
    value: 'FOOD',
    label: 'Food'
  },
  {
    value: 'ECOMMERCE',
    label: 'E-commerce'
  },
  {
    value: "PRESS_FREEDOM",
    label: "Freedom of press and speech"
  },
  {
    value: "LGBT",
    label: "LGBT+"
  },
  {
    value: "CORRUPTION",
    label: "Corruption"
  },
  {
    value: "RELIGIOUS_AFFAIRS",
    label: "Religious Affairs"
  },
  {
    value: "HUMAN_RIGHTS",
    label: "Human Rights"
  },
  {
    value: "CHINA",
    label: "China"
  },
  {
    value: "USA",
    label: "United States"
  },
  {
    value: "Israel_Palestina",
    label: "Israel - Palestina"
  },
  {
    value: "WAR_IN_UKRAINE",
    label: "War in Ukraine"
  },
  {
    value: "KAZAKH_IDENTITY",
    label: "Kazakh identity and sovereignty"
  },
  {
    value: "IRAN",
    label: "Iran"
  },
]

export const TOPICS_OPTIONS_UCBI = [
  {
    value: 'POLITICS',
    label: 'Politics',
  },
  {
    value: 'FINANCE',
    label: 'Economy and finance',
  },
  {
    value: 'PUBLIC_COMPANIES',
    label: 'Public companies',
  },
  {
    value: 'ELECTIONS',
    label: 'Elections',
  },
  {
    value: 'THREAT',
    label: 'Threat',
  },
  {
    value: 'DEFENSE',
    label: 'Defence',
  },
  {
    value: 'CYBER',
    label: 'Cyber',
  },
  {
    value: 'EUROPEAN_INTEGRATION',
    label: 'European Integration',
  },
  {
    value: 'UKRAINE__NATO',
    label: 'Ukraine <> NATO',
  },
  {
    value: 'HEALTHCARE',
    label: 'Healthcare',
  },
  {
    value: 'SOCIAL_CULTURAL',
    label: 'Social/cultural',
  },
  {
    value: 'DECOLONIZATION',
    label: 'Decolonization',
  },
  {
    value: 'ENERGY_INDEPENDENCE',
    label: 'Energy Independence',
  },
  {
    value: 'ANTI_CORRUPTION',
    label: 'Anti-corruption',
  },
  {
    value: 'ECOLOGY',
    label: 'Ecology',
  },
  {
    value: 'POST_WAR_RECOVERY',
    label: 'Reconsruction of Ukraine',
  },
  {
    value: 'BUSINESS_AND_INVESTMENTS',
    label: 'Business & investments',
  },
  {
    value: 'PUBLIC_SERVICES',
    label: 'Public services',
  },
  {
    value: 'VOLUNTEERS',
    label: 'Volunteers',
  },
  {
    value: 'NATIONAL_MINORITIES',
    label: 'National minorities',
  },
  {
    value: 'COLLABORANTS',
    label: 'Collaborants',
  },
  {
    value: 'LOCAL_GOVERNMENT',
    label: 'Local Governance',
  },
  {
    value: 'WEAPON_SUPPLY',
    label: 'Weapon supply',
  },
  {
    value: 'UKRAINE__PARTNERS',
    label: 'Ukraine <> Partners',
  },
  {
    value: 'REFORMS',
    label: 'Reforms',
  },
  {
    value: 'REGION_SPECIFIC',
    label: 'Region-specific',
  },
  {
    value: 'RUSSIAN_NARRATIVES',
    label: 'Russian narratives',
  },
  {
    value: 'MOBILIZATION',
    label: 'Mobilization',
  },
  {
    value: 'CONSTITUTIONAL_STATE',
    label: 'Constitutional State',
  },
  {
    value: 'DEFENSE_AND_SECURITY',
    label: 'Defense and Security',
  },
  {
    value: 'ARMED_FORCES_REFORM',
    label: 'Reform of the Armed Forces',
  },
  {
    value: 'ARMED_FORCES_CORRUPTION',
    label: 'Corruption in the Armed Forces',
  },
  {
    value: 'FRONTLINE_REPORT',
    label: 'Frontline report',
  },
  {
    value: 'PEACE_TALKS',
    label: 'Peace talks',
  },
]

export const EC_THREATS_FEATURE_FLAG = 'show_ec_threats_taxonomy_filters';

export const isEcThreatsEnabled = (currentUser) =>
  Boolean(currentUser?.workspace?.config?.featureflags?.includes(EC_THREATS_FEATURE_FLAG));

export const EC_TOPICS_OPTIONS = [
  { value: 'MERCOSUR', label: 'Mercosur' },
  { value: 'PA_ADMINISTRATION_INSTITUTIONAL_AFFAIRS', label: 'PA-Administration, Anti-Fraud, Communication, Institutional Affairs' },
  { value: 'PA_AGRICULTURE', label: 'PA-Agriculture' },
  { value: 'PA_ANTI_FRAUD', label: 'PA-Anti-Fraud' },
  { value: 'PA_BUDGET', label: 'PA-Budget' },
  { value: 'PA_BUDGET_ECONOMIC_AFFAIRS', label: 'PA-Budget, Economic Affairs, Internal Market, Industry, Entrepreneurship, Financial Services, Taxation' },
  { value: 'PA_CLIMATE_ACTION', label: 'PA-Climate Action' },
  { value: 'PA_COMPETITION', label: 'PA-Competition' },
  { value: 'PA_CONSUMER_POLICY', label: 'PA-Consumer Policy' },
  { value: 'PA_CRISIS_PREPAREDNESS', label: 'PA-Crisis Preparedness' },
  { value: 'PA_CULTURE', label: 'PA-Culture' },
  { value: 'PA_DEFENCE', label: 'PA-Defence' },
  { value: 'PA_DEMOCRACY', label: 'PA-Democracy' },
  { value: 'PA_DEMOGRAPHY', label: 'PA-Demography' },
  { value: 'PA_DIGITAL_ECONOMY', label: 'PA-Digital Economy' },
  { value: 'PA_ECONOMIC_AFFAIRS', label: 'PA-Economic Affairs' },
  { value: 'PA_EDUCATION', label: 'PA-Education' },
  { value: 'PA_EMPLOYMENT', label: 'PA-Employment' },
  { value: 'PA_EMPLOYMENT_SOCIAL_AFFAIRS', label: 'PA-Employment, Social Affairs, Education, Culture, Demography' },
  { value: 'PA_ENERGY', label: 'PA-Energy' },
  { value: 'PA_ENERGY_HOUSING', label: 'PA-Energy & Housing' },
  { value: 'PA_ENLARGEMENT', label: 'PA-Enlargement' },
  { value: 'PA_ENLARGEMENT_FOREIGN_AFFAIRS', label: 'PA-Enlargement, European Neighbourhood, International Cooperation, EU Foreign Affairs' },
  { value: 'PA_ENTREPRENEURSHIP', label: 'PA-Entrepreneurship' },
  { value: 'PA_ENVIRONMENT', label: 'PA-Environment' },
  { value: 'PA_EU_FOREIGN_AFFAIRS', label: 'PA-EU Foreign Affairs' },
  { value: 'PA_EUROPEAN_NEIGHBOURHOOD', label: 'PA-European Neighbourhood' },
  { value: 'PA_FINANCIAL_SERVICES', label: 'PA-Financial Services' },
  { value: 'PA_FOOD_SAFETY', label: 'PA-Food Safety' },
  { value: 'PA_GENDER_EQUALITY', label: 'PA-Gender Equality' },
  { value: 'PA_HEALTH', label: 'PA-Health' },
  { value: 'PA_HEALTH_FOOD_SAFETY', label: 'PA-Health & PA-Food Safety' },
  { value: 'PA_HOME_AFFAIRS', label: 'PA-Home Affairs' },
  { value: 'PA_HOUSING', label: 'PA-Housing' },
  { value: 'PA_HUMANITARIAN_AID', label: 'PA-Humanitarian Aid' },
  { value: 'PA_INDUSTRY', label: 'PA-Industry' },
  { value: 'PA_INSTITUTIONAL_AFFAIRS', label: 'PA-Institutional Affairs' },
  { value: 'PA_INTERNAL_MARKET', label: 'PA-Internal Market' },
  { value: 'PA_INTERNATIONAL_COOPERATION', label: 'PA-International Cooperation' },
  { value: 'PA_JUSTICE', label: 'PA-Justice' },
  { value: 'PA_MARITIME_AFFAIRS', label: 'PA-Maritime Affairs' },
  { value: 'PA_MIGRATION', label: 'PA-Migration' },
  { value: 'PA_MIGRATION_HOME_AFFAIRS', label: 'PA-Migration, PA-Home Affairs' },
  { value: 'PA_REGIO', label: 'PA-Regio' },
  { value: 'PA_RESEARCH_SCIENCE_INNOVATION', label: 'PA-Research, Science and Innovation' },
  { value: 'PA_RULE_OF_LAW', label: 'PA-Rule of Law' },
  { value: 'PA_RULE_OF_LAW_JUSTICE', label: 'PA-Rule of Law, Democracy, Consumer Policy, Justice' },
  { value: 'PA_SOCIAL_AFFAIRS', label: 'PA-Social Affairs' },
  { value: 'PA_TAXATION', label: 'PA-Taxation' },
  { value: 'PA_TRADE', label: 'PA-Trade' },
  { value: 'PA_TRANSPORT', label: 'PA-Transport' },
  { value: 'THE_EU', label: 'The EU' },
];

export const TTP_OPTIONS = [
  { value: 'FACILITATE_STATE_PROPAGANDA', label: 'Facilitate State Propaganda' },
  { value: 'LEVERAGE_EXISTING_NARRATIVES', label: 'Leverage Existing Narratives' },
  { value: 'USE_EXISTING_HASHTAG', label: 'Use Existing Hashtag' },
  { value: 'CREATE_CLICKBAIT', label: 'Create Clickbait' },
  { value: 'CONDUCT_CROWDFUNDING_CAMPAIGNS', label: 'Conduct Crowdfunding Campaigns' },
  { value: 'AMPLIFY_EXISTING_CONSPIRACY_THEORY_NARRATIVES', label: 'Amplify Existing Conspiracy Theory Narratives' },
  { value: 'DEVELOP_ORIGINAL_CONSPIRACY_THEORY_NARRATIVES', label: 'Develop Original Conspiracy Theory Narratives' },
  { value: 'ONLINE_POLLS', label: 'Online Polls' },
  { value: 'DEMAND_INSURMOUNTABLE_PROOF', label: 'Demand Insurmountable Proof' },
  { value: 'BOYCOTT_CANCEL_OPPONENTS', label: 'Boycott/"Cancel" Opponents' },
  { value: 'HARASS_PEOPLE_BASED_ON_IDENTITIES', label: 'Harass People Based on Identities' },
  { value: 'THREATEN_TO_DOX', label: 'Threaten to Dox' },
  { value: 'DOX', label: 'Dox' },
  { value: 'CONDUCT_SWARMING', label: 'Conduct Swarming' },
  { value: 'PAY_FOR_PHYSICAL_ACTION', label: 'Pay for Physical Action' },
  { value: 'CONDUCT_SYMBOLIC_ACTION', label: 'Conduct Symbolic Action' },
  { value: 'CONTINUE_TO_AMPLIFY', label: 'Continue to Amplify' },
  { value: 'SELL_MERCHANDISE', label: 'Sell Merchandise' },
  { value: 'DEGRADE_ADVERSARY', label: 'Degrade Adversary' },
  { value: 'RESPOND_TO_BREAKING_NEWS_EVENT_OR_ACTIVE_CRISIS', label: 'Respond to Breaking News Event or Active Crisis' },
  { value: 'DISCREDIT_CREDIBLE_SOURCES', label: 'Discredit Credible Sources' },
  { value: 'DISTORT', label: 'Distort' },
  { value: 'DISTRACT', label: 'Distract' },
  { value: 'DISMAY', label: 'Dismay' },
  { value: 'DIVIDE', label: 'Divide' },
  { value: 'DEVELOP_NEW_NARRATIVES', label: 'Develop New Narratives' },
  { value: 'INTEGRATE_TARGET_AUDIENCE_VULNERABILITIES_INTO_NARRATIVE', label: 'Integrate Target Audience Vulnerabilities into Narrative' },
  { value: 'APPROPRIATE_CONTENT', label: 'Appropriate Content' },
  { value: 'DEVELOP_AI_GENERATED_TEXT', label: 'Develop AI-Generated Text' },
  { value: 'DEVELOP_INAUTHENTIC_NEWS_ARTICLES', label: 'Develop Inauthentic News Articles' },
  { value: 'DEVELOP_OPINION_ARTICLE', label: 'Develop Opinion Article' },
  { value: 'MACHINE_TRANSLATED_TEXT', label: 'Machine Translated Text' },
  { value: 'DEVELOP_OWNED_MEDIA_ASSETS', label: 'Develop Owned Media Assets' },
  { value: 'JOURNALIST_PERSONA', label: 'Journalist Persona' },
  { value: 'ACTIVIST_PERSONA', label: 'Activist Persona' },
  { value: 'HACKTIVIST_PERSONA', label: 'Hacktivist Persona' },
  { value: 'MILITARY_PERSONNEL_PERSONA', label: 'Military Personnel Persona' },
  { value: 'RESEARCHER_PERSONA', label: 'Researcher Persona' },
  { value: 'EXPERT_PERSONA', label: 'Expert Persona' },
  { value: 'PARTY_OFFICIAL_PERSONA', label: 'Party Official Persona' },
  { value: 'GOVERNMENT_OFFICIAL_PERSONA', label: 'Government Official Persona' },
  { value: 'INSTITUTIONAL_PERSONA', label: 'Institutional Persona' },
  { value: 'FACT_CHECKING_ORGANISATION_PERSONA', label: 'Fact Checking Organisation Persona' },
  { value: 'THINK_TANK_PERSONA', label: 'Think Tank Persona' },
  { value: 'BUSINESS_PERSONA', label: 'Business Persona' },
  { value: 'GOVERNMENT_INSTITUTION_PERSONA', label: 'Government Institution Persona' },
  { value: 'NGO_PERSONA', label: 'NGO Persona' },
  { value: 'CREATE_INAUTHENTIC_NEWS_SITES', label: 'Create Inauthentic News Sites' },
  { value: 'LEVERAGE_EXISTING_INAUTHENTIC_NEWS_SITES', label: 'Leverage Existing Inauthentic News Sites' },
  { value: 'CREATE_LOCALISED_CONTENT', label: 'Create Localised Content' },
  { value: 'FORMAL_DIPLOMATIC_CHANNELS', label: 'Formal Diplomatic Channels' },
  { value: 'TV', label: 'TV' },
  { value: 'POST_ACROSS_GROUPS', label: 'Post across Groups' },
  { value: 'POST_ACROSS_PLATFORM', label: 'Post across Platform' },
  { value: 'USE_CONTESTS_AND_PRIZES', label: 'Use Contests and Prizes' },
  { value: 'BYPASS_CONTENT_BLOCKING', label: 'Bypass Content Blocking' },
  { value: 'DIRECT_USERS_TO_ALTERNATIVE_PLATFORMS', label: 'Direct Users to Alternative Platforms' },
  { value: 'CALL_TO_ACTION_TO_ATTEND', label: 'Call to Action to Attend' },
  { value: 'ENCOURAGE_PHYSICAL_VIOLENCE', label: 'Encourage Physical Violence' },
  { value: 'DENY_INVOLVEMENT', label: 'Deny Involvement' },
  { value: 'SMEAR', label: 'Smear' },
  { value: 'THWART', label: 'Thwart' },
  { value: 'POLARISE', label: 'Polarise' },
  { value: 'DEFEND_REPUTATION', label: 'Defend Reputation' },
  { value: 'JUSTIFY_ACTION', label: 'Justify Action' },
  { value: 'ENERGISE_SUPPORTERS', label: 'Energise Supporters' },
  { value: 'BOOST_REPUTATION', label: 'Boost Reputation' },
  { value: 'CULTIVATE_SUPPORT_FOR_INITIATIVE', label: 'Cultivate Support for Initiative' },
  { value: 'CULTIVATE_SUPPORT_FOR_ALLY', label: 'Cultivate Support for Ally' },
  { value: 'RECRUIT_MEMBERS', label: 'Recruit Members' },
  { value: 'RAISE_FUNDS', label: 'Raise Funds' },
  { value: 'ENCOURAGE', label: 'Encourage' },
  { value: 'PROVOKE', label: 'Provoke' },
  { value: 'COMPEL', label: 'Compel' },
  { value: 'DISCOURAGE', label: 'Discourage' },
  { value: 'SILENCE', label: 'Silence' },
  { value: 'DETER', label: 'Deter' },
  { value: 'DEFAME', label: 'Defame' },
  { value: 'INTIMIDATE', label: 'Intimidate' },
  { value: 'SPREAD_HATE', label: 'Spread Hate' },
  { value: 'VERIFIED_ACCOUNT_ASSET', label: 'Verified Account Asset' },
  { value: 'AUTOMATED_ACCOUNT_ASSET', label: 'Automated Account Asset' },
  { value: 'CROWDFUNDING_PLATFORM', label: 'Crowdfunding Platform' },
  { value: 'ECOMMERCE_PLATFORM', label: 'eCommerce Platform' },
  { value: 'CRYPTOCURRENCY_EXCHANGE_PLATFORM', label: 'Cryptocurrency Exchange Platform' },
  { value: 'CRYPTOCURRENCY_WALLET', label: 'Cryptocurrency Wallet' },
  { value: 'LOOKALIKE_DOMAIN', label: 'Lookalike Domain' },
  { value: 'ONLINE_COMMUNITY_GROUP', label: 'Online Community Group' },
  { value: 'CHAT_COMMUNITY_SERVER', label: 'Chat Community Server' },
  { value: 'DATING_PLATFORM', label: 'Dating Platform' },
  { value: 'SHORTENED_LINK_ASSET', label: 'Shortened Link Asset' },
  { value: 'GEOBLOCKED_ASSET', label: 'Geoblocked Asset' },
];

export const EC_THREATS_EXTRA_SORTING = [
  { name: 'Most recent', value: 'last_message_date_publicated' },
  { name: 'Most views', value: 'impressions' },
  { name: 'Highest engagement', value: 'engagement' },
  { name: 'Most High-Risk accounts', value: 'high_risk_accounts' },
  { name: 'Most publications', value: 'total_messages' },
];

export const withEcThreatsSorting = (menu, enabled, t) => {
  if (!enabled) {
    return menu;
  }
  const present = new Set(menu.map((item) => item.value));
  return [
    ...menu,
    ...EC_THREATS_EXTRA_SORTING.filter((item) => !present.has(item.value)).map((item) => ({ ...item, name: t(item.name) })),
  ];
};
